export default __webpack_public_path__ + "retweet-arrows-symbol.png";